import { OktaAuth } from '@okta/okta-auth-js'

const oktaAuth = new OktaAuth({
  issuer: process.env.NEXT_PUBLIC_OKTA_ISSUER!,
  clientId: process.env.NEXT_PUBLIC_OKTA_CLIENT_ID,
  redirectUri: '/callback',
  pkce: true,
  scopes: ['openid', 'email', 'profile', 'offline_access']
})

export default oktaAuth
